<template>
    <v-dialog v-model="dialog" max-width="758" content-class="elevation-0" v-if="isReady">
        <v-row no-gutters class="standard-row font-theme" align="center">
            <v-tabs background-color="transparent" height="21" v-model="selectedGroupTap" slider-color="#0B68D6" color="black" class="tab-add-group-budget-dashboard">
                <v-tab class="each-tab-add-group-budget-dashboard mr-1" active-class="active-selected-add-group-budget-dashboard" href="#group">เพิ่ม Group</v-tab>
                <v-tab class="each-tab-add-group-budget-dashboard mr-1" active-class="active-selected-add-group-budget-dashboard" href="#sub_group1">เพิ่ม Sub 1</v-tab>
                <v-tab class="each-tab-add-group-budget-dashboard mr-1" active-class="active-selected-add-group-budget-dashboard" href="#sub_group2">เพิ่ม Sub 2</v-tab>
                <v-tab class="each-tab-add-group-budget-dashboard" active-class="active-selected-add-group-budget-dashboard" href="#sub_group3">เพิ่ม Sub 3</v-tab>
            </v-tabs>
        </v-row>
        <v-card class="font-theme standard-row add-group-budget-dashboard-card-modal pt-8 pb-3">
            <v-tabs-items v-model="selectedGroupTap">
                <v-tab-item value="group">
                    <v-form ref="group" lazy-validation>
                        <v-row v-for="(group_type, index) in selectorGroupLoop[0].name_dropdown" :key="`${group_type}${index}`" no-gutters class="standard-row font-theme pb-5" align="center">
                            <v-col cols="12" sm="2" md="2" lg="2" style="font-size: 20px; font-weight: 700;" class="pl-3 pl-sm-4 pl-md-7 mr-md-n3">
                                {{ group_type }}
                            </v-col>
                            <v-col cols="12" sm="8" md="8" lg="8" class="pl-3 pl-sm-4 pl-md-0 pr-3 pr-md-5">
                                <v-tooltip top :disabled="selectorGroupLoop[0].valuable[index][group_type]? false : true">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field hide-details outlined v-bind="attrs" v-on="on" height="41" v-model="selectorGroupLoop[0].valuable[index][group_type]" color="back" class="dropdown-add-group-budget-dashboard" :rules="[ v => !!v ]" required></v-text-field>
                                    </template>
                                    <span class="font-theme">{{ selectorGroupLoop[0].valuable[index][group_type] }}</span>
                                </v-tooltip>
                            </v-col>
                            <v-col v-if="$vuetify.breakpoint.smAndUp" cols="12" sm="auto" md="auto" lg="auto" style="font-size: 20px; font-weight: 700;" class="pr-md-7 d-flex justify-end">
                                <v-btn v-if="index === 0" height="47" width="87" color="#0B68D6" :loading="loadingButton" @click="confirmAddGroup(selectedGroupTap)" class="confirm-button-add-group-budget-dashboard-modal mr-4 mr-sm-0">
                                    ยืนยัน
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-tab-item>
                <v-tab-item value="sub_group1">
                    <v-form ref="sub_group1" lazy-validation>
                        <v-row v-for="(group_type, index) in selectorGroupLoop[1].name_dropdown" :key="`${group_type}${index}`" no-gutters class="standard-row font-theme pb-5" align="center">
                            <v-col cols="12" sm="2" md="2" lg="2" style="font-size: 20px; font-weight: 700;" class="pl-3 pl-sm-4 pl-md-7 mr-md-n3">
                                {{ group_type }}
                            </v-col>
                            <v-col cols="12" sm="8" md="8" lg="8" class="pl-3 pl-sm-4 pl-md-0 pr-3 pr-md-5">
                                <v-tooltip top :disabled="selectorGroupLoop[1].valuable[index][group_type]? false : true">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-if="index === selectorGroupLoop[1].name_dropdown.length - 1" v-bind="attrs" v-on="on" hide-details outlined height="41" v-model="selectorGroupLoop[1].valuable[index][group_type]" color="back" class="dropdown-add-group-budget-dashboard" :rules="[ v => !!v ]" required></v-text-field>
                                        <v-select v-else :items="selectorGroupLoop[1].valuable[index].item" v-bind="attrs" v-on="on" v-model="selectorGroupLoop[1].valuable[index][group_type]" item-text="group_name" hide-details outlined dense height="41" append-icon="mdi-chevron-down" color="black" :menu-props="{ bottom: true, offsetY: true }" @change="searchDropdownList(1, index, group_type)" :rules="[ v => !!v ]" required return-object :loading="selectorGroupLoop[1].valuable[index].loading" :disabled="selectorGroupLoop[1].valuable[index].loading" class="dropdown-add-group-budget-dashboard">
                                            <template v-slot:item="data">
                                                <v-list-item-content>
                                                    <v-list-item-title class="font-theme" style="line-height: 28px; font-size: 16px;">{{ data.item.group_name }}</v-list-item-title>
                                                </v-list-item-content>
                                            </template>
                                            <template v-slot:no-data>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-theme" style="line-height: 28px; font-size: 16px;">ไม่พบข้อมูล</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </template>
                                    <span class="font-theme">{{ selectorGroupLoop[1].valuable[index][group_type]?.group_name? selectorGroupLoop[1].valuable[index][group_type].group_name : selectorGroupLoop[1].valuable[index][group_type] }}</span>
                                </v-tooltip>
                            </v-col>
                            <v-col v-if="$vuetify.breakpoint.smAndUp" cols="12" sm="auto" md="auto" lg="auto" style="font-size: 20px; font-weight: 700;" class="pr-md-7 d-flex justify-end">
                                <v-btn height="47" width="87" color="#0B68D6" :loading="loadingButton" @click="confirmAddGroup(selectedGroupTap)" class="confirm-button-add-group-budget-dashboard-modal mr-4 mr-sm-0" :style="index !== 0? 'visibility: hidden;' : ''">
                                    ยืนยัน
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-tab-item>
                <v-tab-item value="sub_group2">
                    <v-form ref="sub_group2" lazy-validation>
                        <v-row v-for="(group_type, index) in selectorGroupLoop[2].name_dropdown" :key="`${group_type}${index}`" no-gutters class="standard-row font-theme pb-5" align="center">
                            <v-col cols="12" sm="2" md="2" lg="2" style="font-size: 20px; font-weight: 700;" class="pl-3 pl-sm-4 pl-md-7 mr-md-n3">
                                {{ group_type }}
                            </v-col>
                            <v-col cols="12" sm="8" md="8" lg="8" class="pl-3 pl-sm-4 pl-md-0 pr-3 pr-md-5">
                                <v-tooltip top :disabled="selectorGroupLoop[2].valuable[index][group_type]? false : true">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-if="index === selectorGroupLoop[2].name_dropdown.length - 1" v-bind="attrs" v-on="on" hide-details outlined height="41" v-model="selectorGroupLoop[2].valuable[index][group_type]" color="back" class="dropdown-add-group-budget-dashboard" :rules="[ v => !!v ]" required></v-text-field>
                                        <v-select v-else :items="selectorGroupLoop[2].valuable[index].item" v-bind="attrs" v-on="on" v-model="selectorGroupLoop[2].valuable[index][group_type]" item-text="group_name" hide-details outlined dense height="41" append-icon="mdi-chevron-down" color="black" :menu-props="{ bottom: true, offsetY: true }" @change="searchDropdownList(2, index, group_type)" :rules="[ v => !!v ]" required :loading="selectorGroupLoop[2].valuable[index].loading" :disabled="selectorGroupLoop[2].valuable[index].loading" return-object class="dropdown-add-group-budget-dashboard">
                                            <template v-slot:item="data">
                                                <v-list-item-content>
                                                    <v-list-item-title class="font-theme" style="line-height: 28px; font-size: 16px;">{{ data.item.group_name }}</v-list-item-title>
                                                </v-list-item-content>
                                            </template>
                                            <template v-slot:no-data>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-theme" style="line-height: 28px; font-size: 16px;">ไม่พบข้อมูล</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </template>
                                    <span class="font-theme">{{ selectorGroupLoop[2].valuable[index][group_type]?.group_name? selectorGroupLoop[2].valuable[index][group_type].group_name : selectorGroupLoop[2].valuable[index][group_type] }}</span>
                                </v-tooltip>
                            </v-col>
                            <v-col v-if="$vuetify.breakpoint.smAndUp" cols="12" sm="auto" md="auto" lg="auto" style="font-size: 20px; font-weight: 700;" class="pr-md-7 d-flex justify-end">
                                <v-btn height="47" width="87" color="#0B68D6" :loading="loadingButton" @click="confirmAddGroup(selectedGroupTap)" class="confirm-button-add-group-budget-dashboard-modal mr-4 mr-sm-0" :style="index !== 0? 'visibility: hidden;' : ''">
                                    ยืนยัน
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-tab-item>
                <v-tab-item value="sub_group3">
                    <v-form ref="sub_group3" lazy-validation>
                        <v-row v-for="(group_type, index) in selectorGroupLoop[3].name_dropdown" :key="`${group_type}${index}`" no-gutters class="standard-row font-theme pb-5" align="center">
                            <v-col cols="12" sm="2" md="2" lg="2" style="font-size: 20px; font-weight: 700;" class="pl-3 pl-sm-4 pl-md-7 mr-md-n3">
                                {{ group_type }}
                            </v-col>
                            <v-col cols="12" sm="8" md="8" lg="8" class="pl-3 pl-sm-4 pl-md-0 pr-3 pr-md-5">
                                <v-tooltip top :disabled="selectorGroupLoop[3].valuable[index][group_type]? false : true">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-if="index === selectorGroupLoop[3].name_dropdown.length - 1" v-bind="attrs" v-on="on" hide-details outlined height="41" v-model="selectorGroupLoop[3].valuable[index][group_type]" color="back" class="dropdown-add-group-budget-dashboard" :rules="[ v => !!v ]" required></v-text-field>
                                        <v-select v-else :items="selectorGroupLoop[3].valuable[index].item" v-bind="attrs" v-on="on" v-model="selectorGroupLoop[3].valuable[index][group_type]" item-text="group_name" hide-details outlined dense height="41" append-icon="mdi-chevron-down" color="black" :menu-props="{ bottom: true, offsetY: true }" @change="searchDropdownList(3, index, group_type)" :rules="[ v => !!v ]" :loading="selectorGroupLoop[3].valuable[index].loading" :disabled="selectorGroupLoop[3].valuable[index].loading" required return-object class="dropdown-add-group-budget-dashboard">
                                            <template v-slot:item="data">
                                                <v-list-item-content>
                                                    <v-list-item-title class="font-theme" style="line-height: 28px; font-size: 16px;">{{ data.item.group_name }}</v-list-item-title>
                                                </v-list-item-content>
                                            </template>
                                            <template v-slot:no-data>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-theme" style="line-height: 28px; font-size: 16px;">ไม่พบข้อมูล</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </template>
                                    <span class="font-theme">{{ selectorGroupLoop[3].valuable[index][group_type]?.group_name? selectorGroupLoop[3].valuable[index][group_type].group_name : selectorGroupLoop[3].valuable[index][group_type] }}</span>
                                </v-tooltip>
                            </v-col>
                            <v-col v-if="$vuetify.breakpoint.smAndUp" cols="12" sm="auto" md="auto" lg="auto" style="font-size: 20px; font-weight: 700;" class="pr-md-7 d-flex justify-end">
                                <v-btn height="47" width="87" color="#0B68D6" :loading="loadingButton" @click="confirmAddGroup(selectedGroupTap)" class="confirm-button-add-group-budget-dashboard-modal mr-4 mr-sm-0" :style="index !== 0? 'visibility: hidden;' : ''">
                                    ยืนยัน
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-tab-item>
            </v-tabs-items>
            <v-row v-if="$vuetify.breakpoint.xsOnly" class="font-theme standard-row d-flex justify-center">
                <v-btn height="47" width="87" color="#0B68D6" :loading="loadingButton" @click="confirmAddGroup(selectedGroupTap)" class="confirm-button-add-group-budget-dashboard-modal mb-5">
                    ยืนยัน
                </v-btn>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
    export default {
        data: () => ({
            dialog: false,
            isReady: false,
            loadingButton: false,
            oldDataDropdown: [],
            selectorGroupLoop: [],
            selectedGroupTap: 'group',
            selectorGroupLoopEmpty: [
                {
                    name_dropdown: ['Group'],
                    valuable: [ {'Group': null} ]
                },
                {
                    name_dropdown: ['Group', 'Sub 1'],
                    valuable: [ { 'Group': null, 'item': null, 'loading': false }, { 'Sub 1': null, 'loading': false } ],
                },
                {
                    name_dropdown: ['Group', 'Sub 1', 'Sub 2'],
                    valuable: [ { 'Group': null, 'item': null, 'loading': false }, { 'Sub 1': null, 'item': null, 'loading': false }, { 'Sub 2': null, 'loading': false, 'loading': false } ]
                },
                {
                    name_dropdown: ['Group', 'Sub 1', 'Sub 2', 'Sub 3'],
                    valuable: [ { 'Group': null, 'item': null, 'loading': false }, { 'Sub 1': null, 'item': null, 'loading': false }, { 'Sub 2': null, 'item': null, 'loading': false }, { 'Sub 3': null, 'loading': false } ]
                }
            ],
            budgetYear: null
        }),
        watch : {
            "selectedGroupTap"() {
                this.selectorGroupLoop = structuredClone(this.selectorGroupLoopEmpty)
                for (let i = 0; i < this.selectorGroupLoop.length; i++) {
                    if (i) {
                        this.selectorGroupLoop[i].valuable[0].item = this.oldDataDropdown.budget.group_budget
                    }
                }
                this.$refs.group?.resetValidation()
                this.$refs.sub_group1?.resetValidation()
                this.$refs.sub_group2?.resetValidation()
                this.$refs.sub_group3?.resetValidation()
            }
        },
        mounted () {
            EventBus.$on('openAddGroupBudgetDashboardModal', this.openDialog)
        },
        beforeDestroy () {
            EventBus.$off('openAddGroupBudgetDashboardModal')
        },
        methods: {
            openDialog(data) {
                this.oldDataDropdown = data
                this.selectorGroupLoop = structuredClone(this.selectorGroupLoopEmpty)
                for (let i = 0; i < this.selectorGroupLoop.length; i++) {
                    if (i) {
                        this.selectorGroupLoop[i].valuable[0].item = data.budget.group_budget
                    }
                }
                this.$refs.group?.resetValidation()
                this.$refs.sub_group1?.resetValidation()
                this.$refs.sub_group2?.resetValidation()
                this.$refs.sub_group3?.resetValidation()
                this.dialog  = true
                this.isReady = true
                this.budgetYear = data.year
            },
            async searchDropdownList(index, index_type, group_type) {
                if (!this.oldDataDropdown.type) {
                    try {
                        this.selectorGroupLoop[index].valuable[index_type + 1].loading = true
                        this.selectorGroupLoop[index].valuable[index_type + 1].item    = []
                        const { data } = await this.axios.post(`${this.$api_url}/group_budget/api/v1/get_group_budget`, {
                            "tax_id"         : this.oldDataDropdown.tax_id                                             || null,
                            "budget_type"    : [ this.oldDataDropdown.budget_type ]                                            || null,
                            "upper_group_id" : this.selectorGroupLoop[index].valuable[index_type][group_type]?._id || null,
                            "year"           : this.budgetYear
                        })
                        if (data.status && data.data.length) {
                            this.selectorGroupLoop[index].valuable[index_type + 1].item = data.data
                        }
                    } catch (error) {
                        console.log(error)
                    } finally {
                        this.selectorGroupLoop[index].valuable[index_type + 1].loading = false
                    }
                } else {
                    this.selectorGroupLoop[index].valuable[index_type + 1].item = this.selectorGroupLoop[index].valuable[index_type][group_type]?.group_budget || []
                }
            },
            async confirmAddGroup(selected_group) {
                let index = null
                switch (selected_group) {
                    case 'group':
                        if (!this.$refs.group?.validate()) {
                            return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
                        }
                        index = 0
                        break;
                    case 'sub_group1':
                        if (!this.$refs.sub_group1?.validate()) {
                            return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
                        }
                        index = 1
                        break;
                    case 'sub_group2':
                        if (!this.$refs.sub_group2?.validate()) {
                            return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
                        }
                        index = 2
                        break;
                    case 'sub_group3':
                        if (!this.$refs.sub_group3?.validate()) {
                            return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
                        }
                        index = 3
                        break;
                }
                let temp_add_group = []
                for (let i = 0; i < this.selectorGroupLoop[index].valuable.length; i++) {
                    if (i !== this.selectorGroupLoop[index].valuable.length - 1) {
                        const temp_data = Object.values(this.selectorGroupLoop[index].valuable[i])[0]
                        temp_add_group.push({ "_id": temp_data._id, "group_name": temp_data.group_name })
                    }
                }
                const temp_data = {
                    tax_id      : this.oldDataDropdown.tax_id,
                    budget_type : this.oldDataDropdown.budget_type,
                    group_name  : Object.values(this.selectorGroupLoop[index].valuable.at(-1))[0],
                    group       : temp_add_group || null,
                    budget_year : this.budgetYear
                }
                try {
                    this.loadingButton = true
                    const { data } = await this.axios.post(`${this.$api_url}/group_budget/api/v1/add_group_budget`, temp_data)
                    if (data.status) {
                        this.dialog = false
                        EventBus.$emit('afterAddGroupBudget')
                        this.alert('เพิ่มข้อมูลสำเร็จ', 'Success', 'success')
                    } else {
                        this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
                    }
                } catch (error) {
                    this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
                    console.log(error);
                } finally {
                    this.loadingButton = false
                }
            },
            alert(title = '', text = 'Fail', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                })
            }
        }
    }
</script>

<style>
    .tab-add-group-budget-dashboard {
        font-weight: 700;
    }

    .active-selected-add-group-budget-dashboard {
        background-color: #0B68D6 !important;
    }

    .each-tab-add-group-budget-dashboard {
        color: white !important;
        text-transform: capitalize !important;
        font-weight: 700;
        font-size: 10px;
        border-radius: 10px 10px 0px 0px;
        background-color: #D2D2D2;
    }

    .add-group-budget-dashboard-card-modal {
        border-radius: 0px 20px 20px 20px !important;
    }

    .confirm-button-add-group-budget-dashboard-modal {
        color: white !important;
        box-shadow: none;
        border-radius: 10px;
        font-weight: 700;
        font-size: 20px !important;
    }

    .dropdown-add-group-budget-dashboard {
        border-radius: 10px;
        font-size: 18px;
    }

    .dropdown-add-group-budget-dashboard .v-input__control .v-input__slot .v-select__slot .v-input__append-inner {
        height: 100%;
        display: flex;
        align-items: center;
    }

    .dropdown-add-group-budget-dashboard .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-select__selection {
        line-height: 30px;
    }

    .dropdown-add-group-budget-dashboard .v-input__control .v-input__slot {
        min-height: auto;
    }

    .dropdown-add-group-budget-dashboard input {
        line-height: 30px;
    }

    @media only screen and (max-width: 600px) {
        .tab-add-group-budget-dashboard.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right) > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
            display: none !important;
        }
    }

    @media only screen and (max-width: 433px) {
        .add-group-budget-dashboard-card-modal {
            border-radius: 0px 0px 20px 20px !important;
        }
    }
</style>